import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { Flex } from '../../../layout/Flex.mjs';
import { Typography } from '../../../typography/Typography.mjs';

function ControllerContainer({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(StyledController, { align: "center", justify: "between", ...props, children });
}
const StyledController = styled(Flex, {
  height: 28,
  px: 14,
  gap: 8
});
function ClearButton({ children, ...props }) {
  return /* @__PURE__ */ jsx(StyledButton, { ...props, children: /* @__PURE__ */ jsx(ActiveableText, { color: "gray", children }) });
}
const InfoText = styled(Typography, {
  fontSize: 12,
  color: "$gray !important"
});
const ActiveableText = styled(Typography, {
  fontSize: 12,
  textDecoration: "underline"
});
const StyledButton = styled("button", {
  background: "none",
  border: "none",
  boxShadow: "none",
  outline: "none",
  cursor: "pointer",
  "&:disabled": {
    cursor: "not-allowed"
  }
});
ControllerContainer.InfoText = InfoText;
ControllerContainer.ClearButton = ClearButton;

export { ControllerContainer as default };
//# sourceMappingURL=ControllerContainer.mjs.map
